import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMagnifierIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	strokeWidth: 1.5,
	stroke: "currentColor",
	"aria-hidden": "true",
	className: "absolute top-3 left-4 z-1 w-4 2xl:w-5 h-5 2xl:h-6 text-blue",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
	})
});
export default SvgMagnifierIcon;
